import { IResponseCartItem } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { IBillEntries } from "@dineout-cart-client/interfaces";

export const isCartDataNonEmpty = (
    ids: { restaurantId: string; selectedOfferId: string; selectedSlotId: number },
    cartItem: IResponseCartItem,
    selectedDealCategory: string,
    billEntries: IBillEntries[],
): boolean => {
    return !isEmpty(ids) && !isEmpty(cartItem) && !isEmpty(selectedDealCategory) && !isEmpty(billEntries);
};
